var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJumpForward = function SvgJumpForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.038 13.198a7.966 7.966 0 0 1 6.595-7.847L9.628 6.356l1.3 1.3 3.262-3.263L10.797 1l-1.3 1.3 1.184 1.184C5.892 4.129 2.2 8.232 2.2 13.198 2.2 18.61 6.589 23 12.002 23c5.414 0 9.802-4.389 9.802-9.802h-1.838a7.964 7.964 0 0 1-15.928 0m6.168 3.378h-1.82v-4.332H6.672v-1.217h.292c.516 0 .896-.107 1.188-.321.282-.204.448-.526.535-.983l.02-.078h1.499zm7.012-2.366c0 1.538-1.09 2.541-2.872 2.541-1.538 0-2.648-.72-2.833-2.093l1.733-.136c.117.516.516.808 1.09.808.711 0 1.14-.448 1.14-1.08 0-.614-.41-1.072-1.14-1.072-.38 0-.7.127-.963.42l-1.636-.147.633-3.806h4.361v1.45h-3.047l-.224 1.188.03.02c.37-.273.876-.4 1.401-.4 1.373 0 2.327.876 2.327 2.307",
    clipRule: "evenodd"
  })));
};
export default SvgJumpForward;